import { Injectable, signal } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import type { PayableUpdateDialogResult } from './payable-update-dialog.component';

@Injectable({ providedIn: 'root' })
export class PayableUpdateDialogStateService
{
    readonly open = signal(false);
    readonly payableId = signal<number | null>(null);

    private _result$: Subject<PayableUpdateDialogResult | null> | null = null;

    ask(payableId: number): Observable<PayableUpdateDialogResult | null> {
        this.answer(null);
        this._result$ = new Subject<PayableUpdateDialogResult | null>();
        this.payableId.set(payableId);
        this.open.set(true);

        return this._result$.asObservable();
    }

    answer(result: PayableUpdateDialogResult | null): void {
        const result$ = this._result$;
        this._result$ = null;
        this.open.set(false);
        result$?.next(result);
        result$?.complete();
    }
}
